export default __webpack_public_path__ + "static/media/Sun.6436551a.svg";